export default "__VITE_ASSET__92f4e0f7__"